const getIncludedDays = (period, serviceDates) => {
  if(serviceDates.length===0){
    return [];
  }

  if(period===0){
    return getIncludedDaysWhenPeriodZero(serviceDates);
  } 
  return getIncludedDaysWhenPeriodGreaterThanZero(serviceDates);
}

// Only consider the first service settings
const getIncludedDaysWhenPeriodGreaterThanZero = (serviceDates) => {
  const bookingDays = [0, 1, 2, 3, 4, 5, 6];
  return bookingDays.filter(el => serviceDates[0].bookingDays.indexOf(converDayNum(el)+"")!==-1);
}

const getIncludedDaysWhenPeriodZero = (serviceDates) => {
  let bookingDays = [0, 1, 2, 3, 4, 5, 6];
  //const bookingDays = serviceDates[0].bookingDays;
  serviceDates.forEach(element => {
    bookingDays = bookingDays.filter(el => element.bookingDays.indexOf(converDayNum(el)+"")!==-1);
  });

  return bookingDays;
}

const converDayNum = (dayNum) => {
  if(dayNum===0){
    return 7;
  }
  return dayNum;
}

export {getIncludedDays};
export default getIncludedDays;